'use strict';

module.exports = require('./invoke.js');



//////////////////
// WEBPACK FOOTER
// ./~/@dp/knb/~/@hfe/hbnb/invoke/index.js
// module id = 4
// module chunks = 0